module.exports = __webpack_public_path__ + "img/gy11.97344778.png";